module.exports = __webpack_public_path__ + "img/_sylvia.8f85efd0.png";